<template>
	<ui-modal @toggle="$emit('toggle')">
		<div class="flex flex-col gap-2" v-if="!loading">
			<ui-title textSize="big" textPosition="left" class="lg:col-span-2 text-slate-700">
				<template v-slot:text>
					<p>Filtres</p>
				</template>
			</ui-title>
			<form @keydown.enter.prevent="doSearch" class="flex flex-col lg:grid lg:grid-cols-2 gap-2">
				<!-- NAME -->
				<form-input placeholder="Prénom, NOM" v-model="form.name"> </form-input>
				<!-- ADRESSE -->
				<form-input placeholder="Code postal, ville" v-model="form.address"> </form-input>
				<!-- PRO ID -->
				<form-input placeholder="Identifiant professionnel (RPPS, ADELI, ...)" v-model="form.pro_id" @keyup.enter="doSearch"> </form-input>
				<!-- EMAIL -->
				<form-input placeholder="Email" v-model="form.email" @keyup.enter="doSearch"> </form-input>
				<!-- TARGETED CONTACT -->
				<form-select :items="targetedOptions" placeholder="Contact ciblé" @valueChange="form.targeted = $event" :value="form.targeted">
				</form-select>
				<!-- STRUCTURE -->
				<h3 class="text-lg border-b-2 mt-2 col-span-2">Structure(s)</h3>
				<form-search type="structure" @select="structureSelect($event)" :replaceOnSelect="true" class="col-span-2"></form-search>

				<h3 class="text-lg border-b-2 mt-2 col-span-2">Délégé(e)s régional(aux)</h3>
				<!-- DROPDOWN ADD DR -->
				<ui-dropdown ref="dropdownTest" class="col-span-2">
					<template #content>
						<form-input placeholder="Recherche" v-model="searchDRs" class="w-full border-none"> </form-input>
						<div
							v-for="DR in searchDR"
							:key="DR.id"
							class="p-3 text-center hover:bg-slate-500 hover:text-white cursor-pointer flex gap-2 justify-center"
							@click="DRAdd(DR)"
							data-trigger="close">
							{{ DR.first_name }} {{ DR.last_name }}
						</div>
					</template>
					<template v-slot:trigger>
						<ui-button class="w-full">
							<template v-slot:icon>
								<i class="fas fa-plus-circle"></i>
							</template>
							<template v-slot:text>Ajouter</template>
						</ui-button>
					</template>
				</ui-dropdown>
				<div class="flex flex-col gap-3 justify-between col-span-2">
					<div class="flex flex-wrap gap-1">
						<div
							v-for="DR in form.dr"
							:key="DR"
							class="text-slate-500 bg-slate-50 border border-slate-800 rounded-md p-2 px-5 whitespace-nowrap relative overflow-hidden cursor-pointer hover:border-red-400 group text-xs"
							@click.prevent="DRDelete(DR)">
							{{ page.props.admin.users.find((user) => user.id == DR)?.first_name }}
							{{ page.props.admin.users.find((user) => user.id == DR)?.last_name }}
							<div
								class="absolute top-0 left-0 bg-red-500 w-full h-full hidden group-hover:flex items-center justify-center text-white">
								<i class="fas fa-trash"></i>
							</div>
						</div>
					</div>
				</div>

				<!-- SKILLS -->
				<h3 class="text-lg border-b-2 mt-2 col-span-2">Profession(s)</h3>
				<!-- DROPDOWN ADD SKILL -->
				<ui-dropdown ref="dropdownTest" class="col-span-2">
					<template #content>
						<form-input placeholder="Recherche" v-model="searchSkills" class="w-full border-none"> </form-input>
						<div
							v-for="skill in searchSkill.filter((status) => status.type == 'skill')"
							:key="skill.id"
							class="p-3 text-center hover:bg-slate-500 hover:text-white cursor-pointer"
							@click="skillAdd(skill)"
							data-trigger="close">
							{{ skill.name }}
						</div>
					</template>
					<template v-slot:trigger>
						<ui-button class="w-full">
							<template v-slot:icon>
								<i class="fas fa-plus-circle"></i>
							</template>
							<template v-slot:text>Ajouter</template>
						</ui-button>
					</template>
				</ui-dropdown>
				<!-- SKILL LIST -->
				<div class="flex flex-col gap-3 justify-between col-span-2">
					<div class="flex flex-wrap gap-1" v-if="form.skills">
						<div
							v-for="skill in form.skills"
							:key="skill"
							class="text-slate-700 bg-slate-50 border border-blue-500 rounded-md p-2 px-5 whitespace-nowrap relative overflow-hidden cursor-pointer hover:border-red-400 group"
							@click.prevent="skillDelete(skill)">
							{{ page.props.str.statuses.find((element) => element.id == skill)?.name }}
							<div
								class="absolute top-0 left-0 bg-red-500 w-full h-full hidden group-hover:flex items-center justify-center text-white">
								<i class="fas fa-trash"></i>
							</div>
						</div>
					</div>
				</div>
				<!-- ACTIVITIES -->
				<h3 class="text-lg border-b-2 mt-2 col-span-2">Activité(s)</h3>
				<!-- DROPDOWN ADD ACTIVITY -->
				<ui-dropdown ref="dropdownTest" class="col-span-2">
					<template #content>
						<form-input placeholder="Recherche" v-model="searchActivities" class="w-full border-none"> </form-input>
						<div
							v-for="activity in searchActivity.filter((status) => status.type == 'activity')"
							:key="activity.id"
							class="p-3 text-center hover:bg-slate-500 hover:text-white cursor-pointer"
							@click="activityAdd(activity)"
							data-trigger="close">
							{{ activity.name }}
						</div>
					</template>
					<template v-slot:trigger>
						<ui-button class="w-full">
							<template v-slot:icon>
								<i class="fas fa-plus-circle"></i>
							</template>
							<template v-slot:text>Ajouter</template>
						</ui-button>
					</template>
				</ui-dropdown>
				<!-- ACTIVITIES LIST -->
				<div class="flex flex-col gap-3 justify-between col-span-2">
					<div class="flex flex-wrap gap-1" v-if="form.activities">
						<div
							v-for="activity in form.activities"
							:key="activity"
							class="text-slate-700 bg-slate-50 border border-blue-500 rounded-md p-2 px-5 whitespace-nowrap relative overflow-hidden cursor-pointer hover:border-red-400 group"
							@click.prevent="activityDelete(activity)">
							{{ page.props.str.statuses.find((element) => element.id == activity)?.name }}
							<div
								class="absolute top-0 left-0 bg-red-500 w-full h-full hidden group-hover:flex items-center justify-center text-white">
								<i class="fas fa-trash"></i>
							</div>
						</div>
					</div>
				</div>
				<!-- CONTACT PREFERENCE -->
				<form-checkbox
					:items="page.props.str.statuses.filter((status) => status.type == 'communication')"
					v-model="form.infos.communication"
					label="Modes de communication"
					class="col-span-2">
				</form-checkbox>
				<!-- VISIT PREFERENCE -->
				<form-radio
					v-if="page.props.str.statuses.filter((status) => status.type == 'visit').length > 0"
					:items="page.props.str.statuses.filter((status) => status.type == 'visit')"
					v-model="form.infos.visit"
					label="Type de visite"
					class="col-span-2">
				</form-radio>
				<ui-button type="button" @click="doSearch" class="col-span-2 mt-3 font-bold border-2" position="center">
					<template v-slot:text>Rechercher</template>
				</ui-button>
			</form>
		</div>
		<div v-else class="h-full w-full flex items-center justify-center text-2xl">
			<i class="fas fa-circle-notch fa-spin"></i>
		</div>
	</ui-modal>
</template>

<script setup>
	import { ref, computed, onMounted } from 'vue';
	import { usePage, router } from '@inertiajs/vue3';
	import { toast } from 'vue3-toastify';

	const page = usePage();

	const props = defineProps({
		searchForm: {
			type: Object,
			default: null,
		},
		type: {
			type: String,
			default: 'contact',
		},
	});

	const emit = defineEmits(['toggle']);

	const loading = ref(false);
	const searchSkills = ref('');
	const searchActivities = ref('');
	const searchDRs = ref('');
	const searchResult = ref([]);
	const targetedOptions = [
		{ value: '1', name: 'Oui' },
		{ value: '0', name: 'Non' },
	];

	const form = ref({
		name: null,
		address: null,
		pro_id: null,
		dr_id: null,
		skills: [],
		activities: [],
		dr: page.props.auth.user.role === 'admin' ? [] : [page.props.auth.user.id],
		email: null,
		targeted: null,
		infos: {
			communication: [],
			visit: [],
		},
		structure: null,
	});

	const doSearch = () => {
		loading.value = true;
		if (props.type === 'contact') {
			router.get(route('contacts.index'), {
				params: form.value,
			});
		} else if (props.type === 'contrat') {
			router.get(route('contrats.index'), {
				params: form.value,
			});
		}
	};

	const searchSkill = computed(() => {
		if (searchSkills.value) {
			return page.props.str.statuses.filter((w) => w.name.toLowerCase().includes(searchSkills.value.toLowerCase()));
		}
		return page.props.str.statuses;
	});

	const searchActivity = computed(() => {
		if (searchActivities.value) {
			return page.props.str.statuses.filter((w) => w.name.toLowerCase().includes(searchActivities.value.toLowerCase()));
		}
		return page.props.str.statuses;
	});

	const searchDR = computed(() => {
		if (searchDRs.value) {
			const search = searchDRs.value.toLowerCase();
			return page.props.admin.users.filter(
				(user) => user.first_name.toLowerCase().includes(search) || user.last_name.toLowerCase().includes(search),
			);
		}

		return page.props.admin.users;
	});

	const skillAdd = (skill) => {
		if (form.value.skills.includes(skill.id)) {
			toast.error('La profession est déjà présente dans la liste');
		} else {
			form.value.skills.push(skill.id);
		}
	};

	const skillDelete = (skill) => {
		form.value.skills = form.value.skills.filter((element) => element != skill);
	};

	const DRAdd = (DR) => {
		if (form.value.dr.includes(DR.id)) {
			toast.error('Le DR est déjà présent dans la liste');
		} else {
			form.value.dr.push(DR.id);
		}
	};

	const DRDelete = (DR) => {
		form.value.dr = form.value.dr.filter((id) => id != DR);
	};

	const activityAdd = (activity) => {
		if (form.value.activities.includes(activity.id)) {
			toast.error("L'activité est déjà présente dans la liste");
		} else {
			form.value.activities.push(activity.id);
		}
	};

	const activityDelete = (activity) => {
		form.value.activities = form.value.activities.filter((element) => element != activity);
	};

	const structureSelect = (structure) => {
		form.value.structure = structure.id;
	};

	onMounted(() => {
		if (props.searchForm != null) {
			form.value.name = props.searchForm.name ? props.searchForm.name : null;
			form.value.address = props.searchForm.address ? props.searchForm.address : null;
			form.value.pro_id = props.searchForm.pro_id ? props.searchForm.pro_id : null;
			form.value.dr_id = props.searchForm.dr_id ? props.searchForm.dr_id : null;
			form.value.skills = props.searchForm.skills ? props.searchForm.skills : [];
			form.value.activities = props.searchForm.activities ? props.searchForm.activities : [];
			form.value.dr = props.searchForm.dr ? props.searchForm.dr : [];
			form.value.infos = props.searchForm.infos ? props.searchForm.infos : {};
			form.value.structure = props.searchForm.structure ? props.searchForm.structure : '';
			form.value.email = props.searchForm.email ? props.searchForm.email : null;
			form.value.targeted = props.searchForm.targeted ?? null;
		}
	});
</script>
